import React, { useEffect } from 'react';
import '../../App.css';
import Footer from '../Footer';
import HomeGallery from '../HomeGallery';


function PortfolioSports() {
    useEffect(() => {
            const timer = setTimeout(() => {
                window.scrollTo({ top: window.innerHeight * 0.75, behavior: 'smooth' });
                }, 50);
    
            return () => clearTimeout(timer);
    }, []);
        
  return (
    <>
        <h1 className='portfolio-hero'>Portfolio</h1>

        <h1 className='text'>Sports</h1>

            <div className='portfolio-container'>
                <HomeGallery images={['/images/img-sports-3.jpg','/images/img-sports-4.jpg','/images/img-sports-6.jpg','/images/img-sports-7.jpg','/images/img-sports-8.jpg','/images/img-sports-9.jpg','/images/img-sports-1.jpg']} />
            </div>

        <Footer />
    </>
  )
}

export default PortfolioSports
